import { pinyin } from 'pinyin-pro';

const CJK_RE = /[\u4e00-\u9fff]/;

/** Get pinyin for display. Uses provided pinyin if available, else converts character(s) with pinyin-pro. */
export function getPinyinDisplay(character: string, storedPinyin?: string): string {
  if (storedPinyin?.trim()) return storedPinyin.trim();
  if (!character?.trim()) return '';
  try {
    return pinyin(character, { toneType: 'symbol' }) || '';
  } catch {
    return '';
  }
}

/** Single Hanzi → pinyin (tone marks). Non-Hanzi returns empty. */
export function getCharPinyin(char: string): string {
  if (!char || !CJK_RE.test(char)) return '';
  try {
    return pinyin(char, { toneType: 'symbol' }) || '';
  } catch {
    return '';
  }
}

export type RubyToken =
  | { kind: 'hanzi'; char: string; pinyin: string }
  | { kind: 'raw'; char: string };

/** Split a phrase into Hanzi (with pinyin) vs punctuation/spaces for ruby-style layout. */
export function tokenizeForRuby(text: string): RubyToken[] {
  const out: RubyToken[] = [];
  for (const ch of text) {
    if (CJK_RE.test(ch)) {
      out.push({ kind: 'hanzi', char: ch, pinyin: getCharPinyin(ch) });
    } else {
      out.push({ kind: 'raw', char: ch });
    }
  }
  return out;
}
